"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var StepIndicator_1 = require("./StepIndicator");
exports.default = StepIndicator_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/atoms/StepIndicator/index.js
// module id = 1257
// module chunks = 8